export default __webpack_public_path__ + "static/media/ftmechoZLP.f207bf08.png";